import { render } from "./ServiceDetailspage.vue?vue&type=template&id=202040ef"
import script from "./ServiceDetailspage.vue?vue&type=script&lang=js"
export * from "./ServiceDetailspage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__